module.exports = __webpack_public_path__ + "img/ia-01-1.327b11b1.jpg";